import './MainPageSub05_2.scss';

import React from "react";

const MainPageSub05_2 = () => {
    return (
        <div className="MainPageSub05_2 table05">
            <section className='sec-main05'>

                <section className='sec-sub1'>
                    <article className='art-main'>
                       
                       <p className="heading-3 title2">전공적합성을 명확하게 로드맵하다!!</p>

                        <section className="description2">
                            <p>
                                <mark>진로</mark>는 <mark>진학</mark>을 분명하게 합니다. <br />
                                <mark>진학</mark>은 <mark>전공</mark>과 <mark>대학 목표설정</mark>을 선명하게 합니다. <br />
                                <mark>전공</mark>과 <mark>대학 목표설정</mark>은 <mark>입시전략</mark>을 명확하게 합니다.
                            </p>
                        </section>

                        <p className="heading-3 title2">입시전략은 초등부터 준비하는 것이다!</p>

                        <section className="description2">
                            <p>
                                빠르면 빠를수록 좋습니다.<br />
                                느리면 느릴수록 혼란만 가중됩니다.<br />
                                목표가 분명하지 않은 상태에서공부력만으로 대학을 결정할 수는 없습니다.<br />
                                고교학점제와 입시정책은 그렇게 구성되어 있습니다.
                            </p>
                        </section>

                        <p className="heading-3 title2">
                            아이공에서는 불분명한 진로와 전공 미결정자를 위한 맞춤 로드맵을 제공하다!
                        </p>

                        <ul className="type-list">
                            <li><span>전국 주요 대학별 <u>전공적합 리스트</u> 제공</span></li>
                            <li><span><u>유형별 맞춤 학습법 및 시험대비전략</u> 제공</span></li>
                        </ul>

                   
                    </article>

                </section>

            </section>
        </div>
    );
};

export default MainPageSub05_2;
